/* DISABLED: moving "Complete the Look" to right after the support line put it inside the
   sticky right-column sidebar of sections/main-product.liquid (that's the support line's real
   DOM parent -- a narrow ~380px column, not the full-width page flow), so the section rendered
   squeezed and cramped instead of full-width. Reverted; the section stays at its natural
   template-order position (full-width, after main-product finishes entirely) until there's a
   layout-safe way to bring it up sooner -- see chat for the follow-up plan. Left as a no-op
   file rather than removing it outright so the script_tag include in layout/theme.liquid still
   resolves cleanly. */
(function(){})();

/* ==== Essential Preorder / Back-in-stock WATCHDOG (product pages) ====
   WHY: the Essential app embed (a <essential-preorder-app-embed> custom element, rendered by an ES-module
   script) is the ONLY thing that draws the Notify-me button, the Backorder/Add-To-Cart button and the
   "Made for you" message. On some phones/loads it silently fails to draw (script slow/failed, app render
   raced, page restored from the back-forward cache...) and a manual refresh fixes it. Rather than guess
   which cause hit a given shopper, this decides DETERMINISTICALLY whether the currently selected variant
   SHOULD have app UI, using the same data the app itself is given (attributes on the embed element) plus
   our own sold-out state:
     - variant is in an ALWAYS preorder campaign, or in an OUT_OF_STOCK campaign with stock <= 0  -> expect the app's preorder button
     - variant is natively sold out + tracked inventory + a store-wide back-in-stock campaign      -> expect the app's notify-me button
   (NB: an EMPTY 'back-in-stock-container' placeholder exists even on in-stock variants, so only the real
   'button' / 'back-in-stock-button' elements count as "UI present".)
   If the expected UI is still absent after a grace period (2.5s on load, 2s after a variant change, always
   waiting for the embed script to have defined its custom element) it: (1) re-creates the embed element
   (lightweight, no reload -- the app simply renders again), then (2) if still missing, does ONE
   sessionStorage-guarded location.reload() per URL+variant (never loops, never while the tab is hidden, while
   the shopper is touching/typing, or while the notify modal is open). Normal in-stock, non-campaign variants
   never trigger anything. Diagnostics: console.warn + sessionStorage['yg-ess-wd-log'] + window.__ygEssWDState. */
(function(){
  if (window.__ygEssWD) return;
  window.__ygEssWD = 1;
  var PROD = /\/products\/[^\/?#]+/, TAG = 'essential-preorder-app-embed';
  var SEL = {
    preorder: '[data-essential-preorder-element="button"]',
    bis: '[data-essential-preorder-element="back-in-stock-button"]'
  };
  var G_FIRST = 2500, G_VARIANT = 2000, G_REMOUNT = 2200, POLL = 700, MAX_UNDEFINED = 15000;
  var T0 = Date.now();
  var st = window.__ygEssWDState = { key: null, since: 0, grace: G_FIRST, remountAt: 0, remounts: 0, settled: false, gaveUp: null, missingLogged: null, definedAt: 0, loadAt: document.readyState === 'complete' ? T0 : 0, lastTouch: 0, touching: false };
  var cache = {};

  function log(msg){
    try { console.warn('[YG] Essential watchdog: ' + msg); } catch (e) {}
    try {
      var a = JSON.parse(sessionStorage.getItem('yg-ess-wd-log') || '[]');
      a.push([new Date().toISOString().slice(11, 23), location.pathname + location.search, msg]);
      sessionStorage.setItem('yg-ess-wd-log', JSON.stringify(a.slice(-30)));
    } catch (e) {}
  }
  function parse(el, name){
    var s = el.getAttribute(name) || '';
    if (cache[name] && cache[name].s === s) return cache[name].v;
    var v = null; try { v = JSON.parse(s); } catch (e) {}
    cache[name] = { s: s, v: v };
    return v;
  }
  function isPDP(){ return PROD.test(location.pathname) && !!document.querySelector('form[action*="/cart/add"]'); }
  function selectedVariant(){
    var i = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return i && i.value ? String(i.value) : null;
  }
  /* returns {v, why:'preorder'|'bis'} when the selected variant should have app UI, else null */
  function expected(){
    var el = document.querySelector(TAG);
    if (!el) return null;
    var v = selectedVariant();
    if (!v) return null;
    var pre = (parse(el, 'preorder-app-data') || {}).preorderCampaigns || [];
    var inv = parse(el, 'inventory-quantity-by-variant-id') || {};
    var q = inv[v], i, j;
    for (i = 0; i < pre.length; i++) {
      var c = pre[i], ct = c.content || {}, sp = (c.placement && c.placement.specificProducts) || [];
      if (ct.marketType && ct.marketType !== 'ALL') continue;
      var hit = false;
      for (j = 0; j < sp.length; j++) { if (String(sp[j]) === v) { hit = true; break; } }
      if (!hit) continue;
      if (ct.preorderType === 'ALWAYS' || (ct.preorderType === 'OUT_OF_STOCK' && typeof q === 'number' && q <= 0)) return { v: v, why: 'preorder' };
    }
    var bis = (parse(el, 'preorder-app-data-back-in-stock') || {}).backInStockCampaigns || [];
    var allBis = false;
    for (i = 0; i < bis.length; i++) { if (bis[i].assignment && bis[i].assignment.type === 'ALL_PRODUCTS') allBis = true; }
    var btn = document.querySelector('.pdp-add');
    var meta = window.YG && window.YG.inventory && window.YG.inventory[v];
    if (allBis && btn && btn.classList.contains('soldout') && meta && meta.inventory_management) return { v: v, why: 'bis' };
    return null;
  }
  function canDisrupt(){
    if (document.visibilityState !== 'visible') return false;
    if (st.touching || Date.now() - st.lastTouch < 1500) return false;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !/^(hidden|button|submit|checkbox|radio)$/i.test(a.type || '')) return false;
    if (document.querySelector('[data-essential-preorder-element^="back-in-stock-pop-up"]')) return false;
    return true;
  }
  function reloadOnce(key, why){
    var k = 'yg-ess-wd:' + key;
    try {
      var p = sessionStorage.getItem(k);
      if (p && Date.now() - Number(p) < 1800000) {
        if (st.gaveUp !== key) { st.gaveUp = key; log('already reloaded once for ' + key + ' - giving up (' + why + ')'); }
        return;
      }
      sessionStorage.setItem(k, String(Date.now()));
    } catch (e) {
      if (st.gaveUp !== key) { st.gaveUp = key; log('sessionStorage unavailable - not reloading'); }
      return;
    }
    log('RELOAD ' + key + ' (' + why + ')');
    window.location.reload();
  }
  /* re-create the embed element: the app renders again from the same attributes (cart snapshot refreshed first) */
  function remount(){
    var el = document.querySelector(TAG);
    if (!el || !(window.customElements && customElements.get(TAG))) return false;
    var f = document.createElement(TAG), i, swapped = false, t;
    for (i = 0; i < el.attributes.length; i++) f.setAttribute(el.attributes[i].name, el.attributes[i].value);
    function swap(){
      if (swapped) return;
      swapped = true;
      var cur = document.querySelector(TAG);
      if (cur && cur.parentNode) cur.parentNode.replaceChild(f, cur);
    }
    try {
      t = setTimeout(swap, 1200);
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c && c.items) f.setAttribute('cart', JSON.stringify(c)); })
        .catch(function(){})
        .then(function(){ clearTimeout(t); swap(); });
    } catch (e) { swap(); }
    return true;
  }
  function tick(){
    var now = Date.now();
    if (!isPDP() || !document.querySelector(TAG)) { st.key = null; st.since = 0; return; }
    var ex = expected();
    if (!ex) { st.key = null; st.since = 0; return; }
    var key = location.pathname + '|' + ex.v + '|' + ex.why;
    if (document.querySelector(SEL[ex.why])) {
      if (st.missingLogged === key) { log('recovered: UI present for ' + key); st.missingLogged = null; }
      st.key = key; st.since = 0; st.remountAt = 0; st.settled = true;
      return;
    }
    /* UI absent: (re)start the grace clock when this is a new key or the UI has only just disappeared */
    if (st.key !== key || !st.since) {
      st.grace = (!st.settled && st.key === null) ? G_FIRST : G_VARIANT;
      st.settled = true;
      st.key = key; st.since = now; st.remountAt = 0;
      return;
    }
    var defined = !!(window.customElements && customElements.get(TAG));
    var ref = Math.max(st.since, st.remountAt, st.definedAt || 0);
    if (now - ref < st.grace) return;
    if (!defined) {
      var loaded = document.readyState === 'complete' && st.loadAt && now - st.loadAt > 2000;
      if (!loaded && now - T0 < MAX_UNDEFINED) return;
      if (!canDisrupt()) return;
      reloadOnce(key, 'app custom element never defined');
      return;
    }
    if (!st.remountAt) {
      log('UI missing for ' + key + ' after ' + (now - st.since) + 'ms - re-creating app embed');
      st.missingLogged = key; st.remountAt = now; st.remounts++; st.grace = G_REMOUNT;
      if (remount()) return;
    }
    if (!canDisrupt()) return;
    reloadOnce(key, 'still missing after re-create');
  }

  try { if (window.customElements && customElements.whenDefined) customElements.whenDefined(TAG).then(function(){ st.definedAt = Date.now(); }); } catch (e) {}
  window.addEventListener('load', function(){ st.loadAt = Date.now(); });
  document.addEventListener('touchstart', function(){ st.touching = true; st.lastTouch = Date.now(); }, { capture: true, passive: true });
  ['touchend', 'touchcancel'].forEach(function(n){ document.addEventListener(n, function(){ st.touching = false; st.lastTouch = Date.now(); }, { capture: true, passive: true }); });
  /* back-forward cache restore: re-evaluate from scratch */
  window.addEventListener('pageshow', function(ev){
    if (!ev.persisted) return;
    st.key = null; st.settled = false; st.since = 0; st.remountAt = 0; st.loadAt = Date.now();
    setTimeout(tick, 400);
  });
  /* tab returns to the foreground: restart the grace period instead of reloading immediately */
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState !== 'visible') return;
    if (st.remountAt) st.remountAt = Date.now(); else if (st.since) st.since = Date.now();
    setTimeout(tick, 600);
  });
  /* variant picked / option clicked: look again soon */
  ['click', 'change'].forEach(function(n){ document.addEventListener(n, function(){ setTimeout(tick, 250); setTimeout(tick, 900); }, true); });
  setInterval(tick, POLL);
  setTimeout(tick, 300);
})();
